import styles from './AnimatedCheckmark.module.scss';

import React from 'react';

/**
 * Source: https://codepen.io/istiaktridip/pen/BZqaOd/
 */
const AnimatedCheckmark = (props) => (
  <div styleName='animated-checkmark'>
      <div styleName='sa-icon sa-success animate'>
          <span styleName='sa-line sa-tip animateSuccessTip'></span>
          <span styleName='sa-line sa-long animateSuccessLong'></span>
          <div styleName='sa-placeholder'></div>
          <div styleName='sa-fix'></div>
      </div>
  </div>
);

export default AnimatedCheckmark;



// WEBPACK FOOTER //
// ./src/components/AnimatedCheckmark.js